import financeStatusSellerPaid from 'Fixtures/payments/commonFixtures/financeStatusNEPaid.json';
import financeStatusSellerUnpaid from 'Fixtures/payments/commonFixtures/financeStatusNEUnpaid.json';
import type { MirageServer } from 'Mirage/types';
import { API_ROUTES } from 'Utilities/routes';

let mockPollingCount = 0;

const initFinanceStatusRoutes = (server: MirageServer): void => {
	server.get(`${API_ROUTES.FINANCE_STATUS}`, () => {
		mockPollingCount += 1;

		if (mockPollingCount >= 3) {
			return financeStatusSellerPaid;
		}

		return financeStatusSellerUnpaid;
	});
};

export default initFinanceStatusRoutes;
